import { transport } from 'config/transport';

export function callApiUpdateBHYT(congDoanId, nunId, bhytId, body) {
    return transport.put(`/congdoan/${congDoanId}/baohiemyte/${nunId}/${bhytId}`, body);
}
